module.exports = __webpack_public_path__ + "img/productData.58b929fc.png";